import hasOwnProperty from '.Object.prototype.hasOwnProperty';
import undefined from '.undefined';
import isArray from '.Array.isArray?=';
import isMap from '.class.isMap';
import isSet from '.class.isSet';
import isDate from '.class.isDate';
import isRegExp from '.class.isRegExp';

import { test_bind, isIdentifier, PropertyName } from './Name';
import Primitive from './Primitive';

var IS_SAFE = /*#__PURE__*/ test_bind(/^[`~!@#%^&*()\-=+[{\]}\\|;:'",<.>\/?\s]/);

export default function exportify (
	object     ,
	options   
		            
		                              
		                          
		                     
		                    
		                    
		                   
		                     
		                     
		                    
		                    
		                         
		                        
		                       
		                   
	 
)         {
	if ( typeof object!=='object' || object===null || isArray(object) || isMap(object) || isSet(object) || isDate(object) || isRegExp(object) ) {
		var $default$ = Primitive(object, undefined       , undefined       , options      );
		if ( $default$ ) {
			$default$ = ( options.default_value || '' ) + $default$;
			return ( IS_SAFE($default$) ? 'export default' + $default$ : 'export default ' + $default$ ) + ( options.value_semicolon || '' ) + ';';
		}
		return '';
	}
	var ES         = options.ES || 0;
	var gteES6          = ES>=6;
	var export_$_ = 'export ' + ( options['let'] || ( gteES6 ? 'const' : 'var' ) ) + ' ';
	var _equal_         = ( options.identifier_equal || '' ) + '=' + ( options.equal_value || '' );
	var _colon_         = ( options.key_colon || '' ) + ':' + ( options.colon_value || '' );
	var semicolon_         = ( options.value_semicolon || '' ) + ';' + ( options.semicolon_next || '' );
	var named         = '';
	var pairs           = [];
	var pairs_length         = 0;
	var open         = '{';
	var close         = '}';
	for ( var key in object ) {
		if ( hasOwnProperty.call(object, key) ) {
			var value = Primitive(object[key], key, object, options      );
			if ( value ) {
				if ( isIdentifier(key, ES) ) {
					named += export_$_ + key + _equal_ + value + semicolon_;
					if ( gteES6 ) { pairs[pairs_length++] = key; }
					else if ( key==='__proto__' && !options.__safe__ ) {
						open = '/*#__PURE__*/function(o){o.__proto__=__proto__;return o}({';
						close = '})';
						pairs[pairs_length++] = '__proto__' + _colon_ + 'null';
					}
					else { pairs[pairs_length++] = key + _colon_ + key; }
				}
				else { pairs[pairs_length++] = PropertyName(key, ES) + _colon_ + value; }
			}
		}
	}
	return named +
		'export default' + ( options.default_value || '' ) + open + (
			pairs_length
				? ( options.open_first || '' ) + pairs.join(( options.value_comma || '' ) + ',' + ( options.comma_next || '' )) + ( options.last_close || '' )
				: ( options.open_close || '' )
		) + close + ';';
};
